const MODEL_ACTION_IDS = [
  'load',
  'warmup',
  'generate',
  'inspect-cache',
  'retry-cache',
  'clear-st2-cache',
  'clear-st3-cache',
  'clear-all-cache',
] as const;

function invalidDiagnosticModelOrigin(value: string | undefined): string | null {
  if (value === undefined) return null;
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return 'model origin must be an absolute URL.';
  }
  if (url.protocol !== 'https:') return 'model origin must use HTTPS.';
  if (url.username || url.password) {
    return 'model origin must not include credentials.';
  }
  if (url.pathname !== '/' || url.search || url.hash) {
    return 'model origin must not include a path, query, or fragment.';
  }
  return null;
}

function renderFatalDiagnosticConfigurationError(message: string): void {
  const root = document.getElementById('origin-benchmark-ui');
  if (!root) throw new Error('Missing #origin-benchmark-ui mount point.');
  root.replaceChildren();
  root.classList.remove('hidden');
  const error = document.createElement('p');
  error.className = 'notice warning';
  error.setAttribute('role', 'alert');
  error.textContent = `Diagnostic origin configuration error: ${message}`;
  root.append(error);
  for (const id of MODEL_ACTION_IDS) {
    const action = document.getElementById(id);
    if (!(action instanceof HTMLButtonElement)) {
      throw new Error(`Missing model action button #${id}.`);
    }
    action.disabled = true;
  }
}

const benchmarkUiEnabled =
  import.meta.env.VITE_ENABLE_ORIGIN_BENCHMARK_UI === '1';
const diagnosticOriginError = benchmarkUiEnabled
  ? invalidDiagnosticModelOrigin(import.meta.env.VITE_MODEL_ORIGIN)
  : null;

if (diagnosticOriginError) {
  renderFatalDiagnosticConfigurationError(diagnosticOriginError);
} else {
  void import('./main');
}
